var map = {
	"./de.json": 375157,
	"./en.json": 140094,
	"./es.json": 117531,
	"./fr.json": 865289,
	"./it.json": 868555,
	"./ja.json": 931057,
	"./ko.json": 110499,
	"./pl.json": 617744,
	"./pt.json": 3598,
	"./ru.json": 369032,
	"./uk.json": 728917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666392;